<template>
  <div class="document">
    <div class="view-title"><translate>Document</translate></div>
    <div class="ssk-wrapper">
      <div class="add-ssk" v-if="isAdmin.is_admin">
        <div class='file-wrapper' @click="$refs['file-upload'].onClick()" v-if="isAdmin">
          <file-base64 :done="uploadFiles" ref="file-upload" :loading="onLoading"></file-base64>
        </div>
        <el-button type="text" :disabled="this.document.fileIds.length === 0" @click="batchDel()">
          <i class="fa fa-trash fa-lg"></i>
          <translate>Delete</translate>
        </el-button>
      </div>
      <!--<div v-if="!loading">-->
        <el-table :data="document.list" style="width: 100%" :row-class-name="tableRowClassName"
                  @selection-change="handleSelectionChange" v-loading="loading">
          <el-table-column type="selection" width="30" v-if="isAdmin.is_admin"></el-table-column>
          <el-table-column :label="attrText.fileName" prop="file_name"></el-table-column>
          <el-table-column :label="attrText.size">
            <template scope="scope">
              <div class="log-list-name">
                <p>{{scope.row.file_size}}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="attrText.users">
            <template scope="scope">
              {{scope.row.account.account}}
            </template>
          </el-table-column>
          <el-table-column :label="attrText.date">
            <template scope="scope">
              {{scope.row.create_time * 1000 | moment('YYYY-MM-DD HH:mm:ss')}}
            </template>
          </el-table-column>
          <el-table-column :label="attrText.action" width="160">
            <template scope="scope">
              <el-button type="text">
                <a class='down-load' :href="document.downUrl" @click.stop="onDown(scope.row.file_uuid)">
                  <translate>Download</translate>
                </a>
              </el-button>
              <el-button type="text" @click="batchDel(scope.row.id)" v-show="isAdmin.is_admin"><translate>Delete</translate></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="document.totalPage > 10">
          <el-pagination layout="prev, pager, next" :total="document.totalPage" :page-size="10"
                         :current-page.sync="document.currentPage" @current-change="onChangePage"></el-pagination>
        </div>
      </div>
    </div>
  <!--</div>-->
</template>

<script>
  import STORE_CONST from '../../store/consts'
  import { baseUrl } from '../../config'
  import fileBase64 from './model/vue-file-base64'
  export default{
    data () {
      return {
        loading: false,
        document: {
          list: [],
          currentPage: 1,
          totalPage: 0,
          fileIds: [],
          uploadOption: {
            file_name: '',
            file_size: ''
          },
          downUrl: ''
        },
        show: false
      }
    },
    computed: {
      attrText () {
        return this.getTransitionText()
      },
      isAdmin () {
        return this.$store.getters.account
      }
    },
    created () {
      this.getFileList()
      console.log('isAdmin', this.isAdmin, this.$store.getters.account)
    },
    methods: {
      onLoading (stadus) {
        this.loading = stadus
      },
      getTransitionText () {
        return {
          fileName: this.$gettext('File Name'),
          size: this.$gettext('Size'),
          users: this.$gettext('Users'),
          date: this.$gettext('Date'),
          action: this.$gettext('Action')
        }
      },
      // 获取文件列表
      getFileList (page) {
        this.loading = true
        let params = {
          params: {
            page: page || 1,
            q: {
              'order_by': [{'field': 'create_time', 'direction': 'desc'}]
            },
            r: Math.random()
          }
        }
        this.$store.dispatch(STORE_CONST.DOCUMENT.GET_LIST, params).then(res => {
          this.document.list = this.$store.getters.document
          this.document.totalPage = res.num_results
          this.loading = false
        }, () => {
          this.loading = true
        })
      },
      // 上传文件
      uploadFiles (file) {
        let base = file.base64.split('base64,')
        let params = {
          file_name: file.name,
          file_size: file.size,
          content: base[1]
        }
        if (params.file_size > 10 * 1024 * 1024) {
          this.$notify({
            message: this.$gettext('The maximum supported file size is 10M.'),
            type: 'warning'
          })
          this.loading = false
        } else {
          this.$store.dispatch(STORE_CONST.DOCUMENT.UPLOAD, params).then(res => {
            this.getFileList(this.document.currentPage)
            this.$notify({
              message: this.$gettext('Upload successfully!'),
              type: 'success'
            })
          })
        }
      },
      // 下载文件
      onDown (id) {
        this.document.downUrl = `${baseUrl}/file/manage?file_uuid=${id}`
      },
      // 删除 批量删除
      batchDel (id) {
        let ids = this.document.fileIds.map(item => {
          return item.id
        })
        this.$confirm(this.$gettext('Are you sure to delete the document?'), this.$gettext('Delete Confirm'), {
          confirmButtonText: this.$gettext('Comfirm'),
          cancelButtonText: this.$gettext('Cancel'),
          type: 'warning'
        }).then(() => {
          let param = {}
          if (id) {
            param = {
              ids: [id]
            }
          } else {
            param = {
              ids: ids
            }
          }
          this.$store.dispatch(STORE_CONST.DOCUMENT.DEL, param).then(res => {
            this.$notify({
              type: 'success',
              message: this.$gettext('Delete successfully!')
            })
            this.getFileList(this.document.currentPage)
          })
        }).catch(() => {
        })
      },
      // 分页
      onChangePage (page) {
        this.document.currentPage = page
        this.getFileList(page)
      },
      // 选择的文件
      handleSelectionChange (val) {
        this.document.fileIds = val
      },
      tableRowClassName (row, index) {
        if (index % 2 === 0) {
          return 'info-row'
        }
        return ''
      }
    },
    components: {
      fileBase64
    }
  }
</script>

<style lang='scss'>
  @import "../../assets/css/variable";
  .document{
    .ssk-wrapper {
      padding: 15px;
      .file-wrapper{
        display: inline-block;
        &:hover{
          cursor: pointer;
        }
      }
      .add-ssk {
        height: 40px;
        line-height: 40px;
        padding:0;
        background-color: #fff;
        border:1px solid $border-color;
        border-bottom: none;
        .upload-demo{
          display: inline-block;
        }
        a{
          color: $textColor;
          .el-icon-plus{
            font-weight: 700;
            font-size: 12px;
            margin-right: 4px;
            background-color: $textColor;
            color: #fff;
            padding: 1px;
            border-radius: 2px;
          }
        }
      }
      a{
        color: #20a0ff;
      }
      .el-checkbox{
        margin-bottom: 0;
        margin-left: 10px;
        .el-checkbox__inner{
          width: 14px;
          height: 14px;
          &::after{
            left: 3px;
            top:0;
          }
        }
      }
      .el-table .cell, .el-table th>div{
        /*padding: 0;*/
        padding-left: 10px;
      }
      .el-table-column--selection .cell {
        padding-left: 3px;
        padding-right: 14px;
      }
    }
  }
  .pagination{
    border: 1px solid $border-color;
    border-top: none;
  }

</style>




// WEBPACK FOOTER //
// document.vue?51244e82